export default __webpack_public_path__ + "static/media/logo.759d6d09.png";